import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { services } from "@/data/services";

export const Footer = () => (
  <footer id="contact" className="bg-[#0A0A0A] text-white pt-24 sm:pt-32 pb-10 overflow-hidden" data-testid="footer-section">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <p className="text-sm uppercase tracking-[0.3em] font-semibold text-[#E80042] mb-8">Say Hello</p>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <Link
          to="/contact"
          data-testid="footer-lets-talk-link"
          className="block font-display uppercase leading-[0.9] text-[18vw] lg:text-[11rem] tracking-tight group"
        >
          <span className="block group-hover:text-[#E80042] transition-colors duration-300">Let's</span>
          <span className="block text-outline-white group-hover:text-[#E80042] transition-colors duration-300" style={{ transitionProperty: "color, -webkit-text-stroke-color" }}>
            Talk.
          </span>
        </Link>
      </motion.div>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10 border-t border-white/15 pt-12">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-3">Contact</p>
          <a href="mailto:alex@wvestudios.co.uk" data-testid="footer-email-link" className="link-underline font-grotesk font-bold text-lg block w-fit">
            alex@wvestudios.co.uk
          </a>
          <a href="tel:01277280512" data-testid="footer-phone-link" className="link-underline font-grotesk font-bold text-lg block w-fit mt-2">
            01277 280 512
          </a>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-3">Services</p>
          <ul className="space-y-2">
            {services.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-white/70 hover:text-[#E80042] transition-colors duration-200 text-sm">
                  {s.title}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/live" data-testid="footer-live-link" className="text-white/70 hover:text-[#E80042] transition-colors duration-200 text-sm">
                Live & Hybrid
              </Link>
            </li>
            <li>
              <Link to="/studios" data-testid="footer-studio-link" className="text-white/70 hover:text-[#E80042] transition-colors duration-200 text-sm">
                The Studios
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-3">Find us</p>
          <p className="font-grotesk font-bold text-lg" data-testid="footer-address">Unit 6 Hodgson Court</p>
          <p className="text-white/50 text-sm mt-1 leading-relaxed">
            Hodgson Way, Wickford,<br />Essex, SS11 8XR
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-3">Group</p>
          <a
            href="https://www.wvegroup.co.uk/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-wve-group-link"
            className="inline-block text-sm font-semibold text-white/70 hover:text-[#E80042] transition-colors duration-200"
          >
            Part of WVE Group ↗
          </a>
        </div>
      </div>

      <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-white/15 pt-8">
        <img
          src="https://customer-assets-rejwkqb3.emergentagent.net/job_design-breakthrough/artifacts/tyi8grfo_Original%20on%20transparent.webp"
          alt="WVE Studios"
          className="h-14 w-auto"
        />
        <div className="flex items-center gap-6">
          <Link to="/terms" data-testid="footer-terms-link" className="text-white/60 hover:text-[#E80042] transition-colors duration-200 text-sm">
            Terms & Conditions
          </Link>
          <Link to="/privacy" data-testid="footer-privacy-link" className="text-white/60 hover:text-[#E80042] transition-colors duration-200 text-sm">
            Privacy Policy
          </Link>
          <p className="text-white/40 text-sm">© {new Date().getFullYear()} WVE Studios. Made loud on purpose.</p>
        </div>
      </div>
    </div>
  </footer>
);
